export const CompareIcon = ({ className = '' }) => {
  return (
    <svg
      className={`${className}`}
      width='14'
      height='13'
      viewBox='0 0 14 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='6.875' cy='6.375' r='5.875' stroke='#1E42C0' />
      <path
        d='M10.1216 5.75669C10.4636 5.75677 10.7399 6.03311 10.74 6.3751C10.74 6.54565 10.6709 6.70043 10.5589 6.81245C10.4469 6.92439 10.2922 6.99349 10.1216 6.99349L7.49338 6.99338L7.49349 9.62161C7.49349 9.79217 7.42439 9.94695 7.31245 10.0589C7.20043 10.1709 7.04565 10.24 6.8751 10.24C6.53311 10.2399 6.25677 9.96359 6.25669 9.6216L6.25674 6.99336L3.62851 6.99341C3.28651 6.99333 3.01018 6.71699 3.0101 6.375C3.01017 6.03301 3.2865 5.75668 3.62849 5.75661L6.25672 5.75672L6.25661 3.12849C6.25668 2.7865 6.53301 2.51017 6.875 2.51009C7.21699 2.51018 7.49333 2.78651 7.49341 3.1285L7.49337 5.75674L10.1216 5.75669Z'
        fill='#1E42C0'
      />
    </svg>
  )
}
